import cn from 'classnames';
import { SchedulerDayColumn } from '@lp/features/Scheduler/types';
import { baseCellClassname, stickyShadowStyles } from '@lp/features/Scheduler/constants';
import { OMSResource, OMSResourcesWithShifts } from '@/api/apis/resources/schedule';
import { useOMSOnCallDayTotalsMap } from '../hooks';

const stickyCellClassname = cn('sticky left-0 px-3 bg-white border-none z-2', stickyShadowStyles);

type OMSOnCallTotalsSubTableProps = {
  dayCols: SchedulerDayColumn[];
  userList: OMSResource[];
  shiftsData: OMSResourcesWithShifts;
};

export const OMSOnCallTotalsSubTable = ({ dayCols, userList, shiftsData }: OMSOnCallTotalsSubTableProps) => {
  const daysTotalsMap = useOMSOnCallDayTotalsMap(dayCols, userList, shiftsData);

  return (
    <tr key="totalOnCallRow" className="bg-white">
      <td className={cn('h-9', stickyCellClassname)}>
        <span className="text-m-m text-base-5">Total On Call</span>
      </td>
      {dayCols.map((column) => (
        <td
          key={column.key}
          className={cn(baseCellClassname, 'text-m-m text-base-5', { 'bg-base-70!': column.isSelectedDay })}
        >
          <div className="flex justify-between w-full px-3">
            <span>{daysTotalsMap.get(column.key)?.slot1}</span>
            <span>{daysTotalsMap.get(column.key)?.slot2}</span>
          </div>
        </td>
      ))}
    </tr>
  );
};
